import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import {forkJoin, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {tap, mergeMap} from 'rxjs/operators';
import {SharedService} from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private shared: SharedService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return forkJoin([this.shared.getToken(), this.shared.getItem('DATOSAPP')]).pipe(
      mergeMap(token => {
        const bbdd = (token[1]) ? token[1].BBDD : 'USERS';
        const bearer: string = 'Bearer ' + token[0];
        const myheaders: HttpHeaders = new HttpHeaders({
          authorization: bearer,
          'x-app': this.shared.APP,
          'x-version': this.shared.VERSION,
          'x-issuer': bbdd
        });
        const authReq: HttpRequest<any> = req.clone({
          headers: myheaders
        });
        return next.handle(authReq).pipe(
          tap(ev => {
            if (ev instanceof HttpResponse) {
              if (ev.headers.get(this.shared.HEADER)) {
                this.shared.setItem('TOKEN', ev.headers.get(this.shared.HEADER)).subscribe()
              }
            }
          })
        )
      })
    )
  }
}
